import React from 'react';
import FileInput from 'components/inputs/FileInput';
import Button from 'components//buttons/Button';
export default function AddImageDesktop({ handleSelectFile, openCam }) {
  // drop and dragover event handler functions from https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/File_drag_and_drop
  const handleDrop = (e) => {
    e.preventDefault();
    let fileObj;

    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      [...e.dataTransfer.items].forEach((item, i) => {
        // If dropped items aren't files, reject them. Only take first item
        if (item.kind === 'file' && i === 0) {
          const file = item.getAsFile();
          fileObj = file;
        }
      });
    } else {
      // Use DataTransfer interface to access the file(s)
      [...e.dataTransfer.files].forEach((file, i) => {
        if (i === 0) {
          fileObj = file;
        }
      });
    }
    handleSelectFile(fileObj);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  return (
    <div
      className="flex flex-col justify-center items-center p-8 border border-dashed border-dk-beige h-[400px] lg:w-[95%] mx-auto"
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <div>Drag file here or...</div>

      <div className="w-full flex flex-col md:flex-row justify-center items-center p-8">
        <FileInput
          label="Choose Image"
          onChange={handleSelectFile}
          id="choose-image-file"
        />

        <Button onClick={openCam} classes="mt-4 md:mt-0 md:ml-4">
          Use Camera to take a photo
        </Button>
      </div>
    </div>
  );
}
